import React from "react";
import { Box, TableCell as TableCellMui, Typography } from "@mui/material";

export const TableCell = ({column, row}) => {
  return (
    <td style={{width: column.width || "unset"}}>
      <Box display="flex" minHeight={58} alignItems="center" width={column.width} overflow="hidden" paddingY={1} justifyContent={column.align || "start"}><Typography variant="body2" component="span" noWrap={column.noWrap}>{column.render ? column.render(row) : row[column.field]}</Typography></Box>
    </td>
  )
}